export default "__VITE_PUBLIC_ASSET__08cd8a1f__"